export const NAME = "copyTiers" as const;

export const COPY_TIERS_MODAL_ID = "COPY_TIERS_MODAL";
